<script setup>
import ContactsCard from '@/components/cards/ContactsCard.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
      data?.background_color === 'black' ? 'white' : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div :class="['contacts-cards', `contacts-cards--${data?.template}`]">
        <h2
          v-if="data.title && data.title.length > 0"
          class="mb-0 contacts-cards__title h2 text-center"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h2>
        <ul
          v-if="data.items && data.items.length > 0"
          class="m-0 p-0 contacts-cards__items"
        >
          <li
            v-for="(item, itemIndex) in data.items"
            :key="itemIndex"
            class="contacts-cards__item"
            data-aos="fade-up"
            :data-aos-delay="itemIndex >= 1 ? 100 + 100 * itemIndex : 100"
          >
            <ContactsCard
              :background-color="data.background_color"
              :title="item.title"
              :description="item.description"
              :address="item.address"
              :phone="item.phone"
              :mail="item.mail"
              :website="item.website"
              :caption="item.caption"
              :time="item.time"
              :template="'contacts'"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.contacts-cards {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 56px;
  margin: 0 auto;
  width: 100%;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0;
  }
  &__items {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    list-style: none;
    padding: 0;
    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(2, 6fr);
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
    }
  }
  &__item {
    margin: 0;
  }
  &--contacts {
    #{$parent} {
      &__items {
        gap: 8px;
        padding: 0 4px;
        @include media-breakpoint-up(md) {
          padding: 0;
        }
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(gap, 8);
        }
      }
    }
  }
}
</style>
